import {
  Box,
  Collapse,
  darken,
  Divider,
  Grid,
  Stack,
  useThemeProps,
  useTheme,
} from "@mui/material";
import { SSButton } from "src/components/base/components/SSButton";
import { SSText } from "src/components/base/components/SSText";
import { useSSTheme } from "src/components/reusable/hooks/useSSTheme";
import { TAddOn, TEvent } from "src/shared/types/globalStotre.types";
import { useHomePageFlow } from "./useHomePageFlow";
import React from "react";
import { AddOnItem } from "./AddOnItem";
import { useEventCardCtx } from "./EventCard";
import {
  getAddOnGroupDetails,
  groupAddOnsBySubCategory,
} from "./utils.homepageFlow";
import { useCssMediaQuery } from "src/components/base/hooks/useCssMediaQuery";
import { useTeamConfig } from "src/components/reusable/components/TeamConfigProvider";
import { AddOnGroupTag } from "./AddOnGroupTag";

export function EventCardSingleGames() {
  const theme = useSSTheme();
  const muiTheme = useTheme();
  const { md: mdUp } = useCssMediaQuery("up");
  const { HOME_PAGE_SETTINGS } = useTeamConfig();
  const eventCardCtx = useEventCardCtx();
  const singleGamesGrouped =
    HOME_PAGE_SETTINGS?.EVENT_CARD?.ADD_ON_DISPLAY_MODE == "grouped"
      ? groupAddOnsBySubCategory(eventCardCtx.singleGames)
      : [];

  return (
    <>
      {HOME_PAGE_SETTINGS?.EVENT_CARD?.ADD_ON_DISPLAY_MODE == "grouped" ? (
        <Stack spacing={2}>
          {singleGamesGrouped?.map((group, idx) => {
            return (
              <Box
                key={idx}
                border={`1px solid ${eventCardCtx.colors.borderColor}`}
                borderRadius={2}
                position={"relative"}
              >
                {group.map((addOn, idx) => {
                  return (
                    <Box key={addOn.productId}>
                      {idx !== 0 ? (
                        <Divider
                          sx={{
                            backgroundColor: eventCardCtx.colors.borderColor,
                            borderColor: "transparent",
                          }}
                        />
                      ) : null}

                      <Box p={2}>
                        <AddOnItem
                          key={addOn.productId}
                          addOn={addOn}
                          isDarkBg={eventCardCtx.isDarkBg}
                          isDisabled={Boolean(addOn?.isOptInRequired) && !Boolean(eventCardCtx?.event?.optedIn)}
                        />
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            );
          })}
        </Stack>
      ) : null}

      {HOME_PAGE_SETTINGS?.EVENT_CARD?.ADD_ON_DISPLAY_MODE == "list" ||
      !HOME_PAGE_SETTINGS?.EVENT_CARD?.ADD_ON_DISPLAY_MODE ? (
        <Box>
          {eventCardCtx.singleGames?.map((addOn) => {
            return (
              <React.Fragment key={addOn.productId}>
                <Divider
                  sx={{
                    backgroundColor: eventCardCtx.colors.borderColor,
                    borderColor: "transparent",
                  }}
                />
                <Box py={mdUp ? 3 : 2}>
                  <AddOnItem
                    key={addOn.productId}
                    addOn={addOn}
                    isDarkBg={eventCardCtx.isDarkBg}
                    isDisabled={Boolean(addOn?.isOptInRequired) && !Boolean(eventCardCtx?.event?.optedIn)}
                    />
                </Box>
              </React.Fragment>
            );
          })}
        </Box>
      ) : null}
    </>
  );
}
